import {useTranslation} from 'lib/i18n';
import {useMemo} from 'react';

export default function useIncomeTypeOptions() {
  const {t} = useTranslation();

  return useMemo(() => t('inputsTranslation:borrower info.income type options', {returnObjects: true}), [t]);
}
